import { API } from '@config';
import { ContactUsContactGPATable } from '@src/types/ContactUsContactGPA';

export const getContactGPA = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/contact-us-contact-gpas?populate=File&sort=id%3Adesc`, options);
  const data: ContactUsContactGPATable = await response.json();

  return data;
};
